import { unitSystemOptions } from '@frontend/core/lib/domains/units'
import type { UnitSystemKeys } from '@frontend/core/lib/domains/units/types'

/** Validates a Radix `onValueChange` string against `unitSystemOptions`,
 *  returning the matching option's value or `null` for an unrecognized one. */
export function resolveUnitSystemChoice(
  value: string
): (UnitSystemKeys | 'Default') | null {
  const match = unitSystemOptions.find((o) => o.value === value)
  return match ? (match.value as UnitSystemKeys | 'Default') : null
}
